/**
 * CatalogsEnum
 */
export enum CatalogsEnum {
  Cities = "sCities",
}
